
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 13.248l-3.494 3.494a.882.882 0 11-1.248-1.248L10.752 12 7.258 8.506a.882.882 0 011.248-1.248L12 10.752l3.494-3.494a.882.882 0 011.248 1.248L13.248 12l3.494 3.494a.882.882 0 11-1.248 1.248L12 13.248z","fill":"#FF583B","fill-rule":"nonzero"}})])
          )
        }
      }
    